import { defineMessages } from 'react-intl';

export default defineMessages({

  relationshipToYou: {
    id: 'fastCover.stepMedicalExpenses.relationshipToYou',
    defaultMessage: "Claimant's Relationship to you",
  },

  nationalIdOrVisa: {
    id: 'fastCover.stepMedicalExpenses.nationalIdOrVisa',
    defaultMessage: 'National ID or Visa #',
  },

  ifYesPleaseProvide: {
    id: 'fastCover.stepMedicalExpenses.ifYesPleaseProvide',
    defaultMessage: "If yes, please provide the carrier's name, address and policy insurance:",
  },

  nationalId: {
    id: 'fastCover.stepMedicalExpenses.nationalId',
    defaultMessage: 'National ID',
  },

  visa: {
    id: 'fastCover.stepMedicalExpenses.visa',
    defaultMessage: 'Visa #',
  },

  id: {
    id: 'fastCover.stepMedicalExpenses.id',
    defaultMessage: 'ID #',
  },

  purposeOfTrip: {
    id: 'fastCover.stepMedicalExpenses.purposeOfTrip',
    defaultMessage: 'Purpose of Trip',
  },

  holiday: {
    id: 'fastCover.stepMedicalExpenses.holiday',
    defaultMessage: 'Holiday',
  },

  business: {
    id: 'fastCover.stepMedicalExpenses.business',
    defaultMessage: 'Business',
  },

  medical: {
    id: 'fastCover.stepMedicalExpenses.medical',
    defaultMessage: 'Medical',
  },

  other: {
    id: 'fastCover.stepMedicalExpenses.other',
    defaultMessage: 'Other',
  },

  ifOtherPleaseDescribe: {
    id: 'fastCover.stepMedicalExpenses.ifOtherPleaseDescribe',
    defaultMessage: 'If other, please describe',
  },

  didYouContactAssistanceCompany: {
    id: 'fastCover.stepMedicalExpenses.didYouContactAssistanceCompany',
    defaultMessage: 'Did you contact our Assistance Company?',
  },

  assistanceCaseReferenceNumberFileNumber: {
    id: 'fastCover.stepMedicalExpenses.assistanceCaseReferenceNumberFileNumber',
    defaultMessage: 'Assistance Case Reference Number / File Number',
  },

  didYouHaveOtherMedicalInsurance: {
    id: 'fastCover.stepMedicalExpenses.didYouHaveOtherMedicalInsurance',
    defaultMessage: 'Did you have other medical insurance?',
  },

  insuranceCarriersName: {
    id: 'fastCover.stepMedicalExpenses.insuranceCarriersName',
    defaultMessage: "Insurance Carrier's Name",
  },

  address: {
    id: 'fastCover.stepMedicalExpenses.address',
    defaultMessage: 'Address',
  },

  cityOrTown: {
    id: 'fastCover.stepMedicalExpenses.cityOrTown',
    defaultMessage: 'City or Town',
  },

  country: {
    id: 'fastCover.stepMedicalExpenses.country',
    defaultMessage: 'Country',
  },

  postalCode: {
    id: 'fastCover.stepMedicalExpenses.postalCode',
    defaultMessage: 'Postal Code',
  },

  policyId: {
    id: 'fastCover.stepMedicalExpenses.policyId',
    defaultMessage: 'Policy ID',
  },

  contact: {
    id: 'fastCover.stepMedicalExpenses.contact',
    defaultMessage: 'Contact',
  },

  email: {
    id: 'fastCover.stepMedicalExpenses.email',
    defaultMessage: 'Email',
  },

  phoneNumber: {
    id: 'fastCover.stepMedicalExpenses.phoneNumber',
    defaultMessage: 'Phone Number',
  },

  areYouACitizenOfTheEuropeanUnion: {
    id: 'fastCover.stepMedicalExpenses.areYouACitizenOfTheEuropeanUnion',
    defaultMessage: 'Are you a citizen of the European Union?',
  },

  forEUCitizens: {
    id: 'fastCover.stepMedicalExpenses.forEUCitizens',
    defaultMessage: 'Was a European Health Insurance Card (EHIC) taken on this trip?',
  },

  ifYesWasTheEHIC: {
    id: 'fastCover.stepMedicalExpenses.ifYesWasTheEHIC',
    defaultMessage: 'If yes, was the EHIC presented to the hospital or physician?',
  },

  hospitalAndMedicalExpenses: {
    id: 'fastCover.stepMedicalExpenses.hospitalAndMedicalExpenses',
    defaultMessage: 'HOSPITAL & MEDICAL EXPENSES (Including prescriptions, x-rays, doctor visits, etc.)',
  },

  accidentStartDate: {
    id: 'fastCover.stepMedicalExpenses.accidentStartDate',
    defaultMessage: 'Accident/Illness Start Date',
  },

  accidentStartDateForIllness: {
    id: 'fastCover.stepMedicalExpenses.accidentStartDate',
    defaultMessage: 'Illness Start Date',
  },

  accidentFirstTreatment: {
    id: 'fastCover.stepMedicalExpenses.accidentFirstTreatment',
    defaultMessage: 'Accident/Illness First Treatment',
  },

  nameOfPhysicianFacilityFirstContacted: {
    id: 'fastCover.stepMedicalExpenses.nameOfPhysicianFacilityFirstContacted',
    defaultMessage: 'Name of Physician/Facility first contacted',
  },

  ifNoPleaseExplain: {
    id: 'fastCover.stepMedicalExpenses.ifNoPleaseExplain',
    defaultMessage: 'If no, please explain',
  },

  isTheClaimTheResultOfAniLLness: {
    id: 'fastCover.stepMedicalExpenses.isTheClaimTheResultOfAnIllness',
    defaultMessage: 'Is the claim the result of an Illness?',
  },

  symptoms: {
    id: 'fastCover.stepMedicalExpenses.symptoms',
    defaultMessage: 'Symptoms',
  },

  details: {
    id: 'fastCover.stepMedicalExpenses.details',
    defaultMessage: 'Details',
  },

  isTheClaimTheResultOfAccidentOrInjury: {
    id: 'fastCover.stepMedicalExpenses.isTheClaimTheResultOfAccidentOrInjury',
    defaultMessage: 'Is the claim the result of accident or injury?',
  },

  place: {
    id: 'fastCover.stepMedicalExpenses.place',
    defaultMessage: 'Place',
  },

  accidentDate: {
    id: 'fastCover.stepMedicalExpenses.accidentDate',
    defaultMessage: 'Accident Date',
  },

  accidentTime: {
    id: 'fastCover.stepMedicalExpenses.accidentTime',
    defaultMessage: 'Accident Time',
  },

  wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity: {
    id: 'fastCover.stepMedicalExpenses.wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity',
    defaultMessage: 'Was the accident or injury the result of playing a sport or due to a hazardous activity?',
  },

  treatingPhysicianFacility: {
    id: 'fastCover.stepMedicalExpenses.treatingPhysicianFacility',
    defaultMessage: 'Treating Physician/Facility',
  },

  treatingPhysicianFacilityFirstContacted: {
    id: 'fastCover.stepMedicalExpenses.treatingPhysicianFacility',
    defaultMessage: 'Treating Physician/Facility',
  },

  phoneNumberForPhysician: {
    id: 'fastCover.stepMedicalExpenses.phoneNumberForPhysician',
    defaultMessage: 'Physician/Facility Phone Number',
  },

  ifPriorTreatmentWasGivenIn: {
    id: 'fastCover.stepMedicalExpenses.ifPriorTreatmentWasGivenIn',
    defaultMessage: 'If prior treatment was given in a hospital, as an inpatient, please provide',
  },

  facilityName: {
    id: 'fastCover.stepMedicalExpenses.facilityName',
    defaultMessage: 'Facility Name',
  },

  admitDate: {
    id: 'fastCover.stepMedicalExpenses.admitDate',
    defaultMessage: 'Admit Date',
  },

  timeOfAdmission: {
    id: 'fastCover.stepMedicalExpenses.timeOfAdmission',
    defaultMessage: 'Time of Admission',
  },

  dischargeDate: {
    id: 'fastCover.stepMedicalExpenses.dischargeDate',
    defaultMessage: 'Discharge Date',
  },

  timeOfDischarge: {
    id: 'fastCover.stepMedicalExpenses.timeOfDischarge',
    defaultMessage: 'Time of Discharge',
  },

  expensesClaimed: {
    id: 'fastCover.stepMedicalExpenses.expensesClaimed',
    defaultMessage: 'Expenses Claimed',
  },

  currency: {
    id: 'fastCover.stepMedicalExpenses.currency',
    defaultMessage: 'Currency',
  },

  didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness: {
    id: 'fastCover.stepMedicalExpenses.didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness',
    defaultMessage: 'Did any physician prohibit you from traveling by air or otherwise due to this injury/Illness?',
  },

  wereYouTravelingToReceiveMedicalTreatment: {
    id: 'fastCover.stepMedicalExpenses.wereYouTravelingToReceiveMedicalTreatment',
    defaultMessage: 'Were you traveling to receive medical treatment?',
  },

  alternativeTreatment: {
    id: 'fastCover.stepMedicalExpenses.alternativeTreatment',
    defaultMessage: 'Alternative Treatment',
  },

  ifYesWhenDidYouLearnOfTheAlternativeTreatment: {
    id: 'fastCover.stepMedicalExpenses.ifYesWhenDidYouLearnOfTheAlternativeTreatment',
    defaultMessage: 'If yes, when did you learn of the alternative treatment?',
  },

  whoRecommendedTheTreatment: {
    id: 'fastCover.stepMedicalExpenses.whoRecommendedTheTreatment',
    defaultMessage: 'Who recommended the treatment?',
  },

  areYouPregnant: {
    id: 'fastCover.stepMedicalExpenses.areYouPregnant',
    defaultMessage: 'Are you pregnant?',
  },

  ifYesNumberOfWeeks: {
    id: 'fastCover.stepMedicalExpenses.ifYesNumberOfWeeks',
    defaultMessage: 'If yes, number of weeks',
  },

  yes: {
    id: 'fastCover.stepMedicalExpenses.yes',
    defaultMessage: 'Yes',
  },

  no: {
    id: 'fastCover.stepMedicalExpenses.no',
    defaultMessage: 'No',
  },
  //---------------------------
  areYouClaimingForDamagedLostOrStolenLuggage: {
    id: 'fastCover.StepMedicalExpenses.areYouClaimingForDamagedLostOrStolenLuggage',
    defaultMessage: 'Are you claiming for Damaged, Lost, or Stolen Luggage?',
  },

  areYouClaimingForBaggageDelay: {
    id: 'fastCover.StepMedicalExpenses.areYouClaimingForBaggageDelay',
    defaultMessage: 'Are you claiming for Baggage Delay?',
  },

  areYouClaimingFor: {
    id: 'fastCover.StepMedicalExpenses.areYouClaimingFor',
    defaultMessage: 'Are you claiming for:',
  },

  travelSupplierProviderInformation: {
    id: 'fastCover.StepMedicalExpenses.travelSupplierProviderInformation',
    defaultMessage: 'Travel Supplier / Provider Information',
  },

  companyYouWereTravelingWith: {
    id: 'fastCover.StepMedicalExpenses.companyYouWereTravelingWith',
    defaultMessage: 'Company you were traveling with:',
  },

  origin: {
    id: 'fastCover.StepMedicalExpenses.origin',
    defaultMessage: 'Origin',
  },

  flightNumber: {
    id: 'fastCover.StepMedicalExpenses.flightNumber',
    defaultMessage: 'Flight Number',
  },

  airCarrier: {
    id: 'fastCover.StepMedicalExpenses.airCarrier',
    defaultMessage: 'Air Carrier',
  },

  destination: {
    id: 'fastCover.StepMedicalExpenses.destination',
    defaultMessage: 'Destination',
  },

  lossInformation: {
    id: 'fastCover.StepMedicalExpenses.lossInformation',
    defaultMessage: 'Loss Information',
  },

  dateOfLoss: {
    id: 'fastCover.StepMedicalExpenses.dateOfLoss',
    defaultMessage: 'Date of Loss',
  },

  pleaseDescribeWhatOccurred: {
    id: 'fastCover.StepMedicalExpenses.pleaseDescribeWhatOccurred',
    defaultMessage: 'Please describe what occurred',
  },

  whoDidYouReportTo: {
    id: 'fastCover.StepMedicalExpenses.whoDidYouReportTo',
    defaultMessage: 'Who did you report to?',
  },

  reportReferenceNumber: {
    id: 'fastCover.StepMedicalExpenses.reportReferenceNumber',
    defaultMessage: 'Report Reference Number',
  },

  nameAndAddress: {
    id: 'fastCover.StepMedicalExpenses.nameAndAddress',
    defaultMessage: 'Name and Address',
  },

  nameCustomerServiceDepartment: {
    id: 'fastCover.StepMedicalExpenses.nameCustomerServiceDepartment',
    defaultMessage: 'Name (Customer Service Department)',
  },

  doYouHaveAnyFurtherDetailsToAdd: {
    id: 'fastCover.StepMedicalExpenses.doYouHaveAnyFurtherDetailsToAdd',
    defaultMessage: 'Do you have any further details to add',
  },

  loss: {
    id: 'fastCover.StepMedicalExpenses.loss',
    defaultMessage: 'Loss',
  },

  theft: {
    id: 'fastCover.StepMedicalExpenses.theft',
    defaultMessage: 'Theft',
  },

  damage: {
    id: 'fastCover.StepMedicalExpenses.damage',
    defaultMessage: 'Damage',
  },

  tourOperator: {
    id: 'fastCover.StepMedicalExpenses.tourOperator',
    defaultMessage: 'Tour Operator',
  },

  cruiseLine: {
    id: 'fastCover.StepMedicalExpenses.cruiseLine',
    defaultMessage: 'Cruise Line',
  },

  airline: {
    id: 'fastCover.StepMedicalExpenses.airline',
    defaultMessage: 'Airline',
  },

  airport: {
    id: 'fastCover.StepMedicalExpenses.airport',
    defaultMessage: 'Airport',
  },

  hotel: {
    id: 'fastCover.StepMedicalExpenses.hotel',
    defaultMessage: 'Hotel',
  },

  rentalAgency: {
    id: 'fastCover.StepMedicalExpenses.rentalAgency',
    defaultMessage: 'Rental Agency',
  },

  police: {
    id: 'fastCover.StepMedicalExpenses.police',
    defaultMessage: 'Police',
  },

  hospitalManagement: {
    id: 'fastCover.StepMedicalExpenses.hospitalManagement',
    defaultMessage: 'Hospital Management',
  },

  cruiseShip: {
    id: 'fastCover.StepMedicalExpenses.cruiseShip',
    defaultMessage: 'Cruise Ship',
  },

  tourGuide: {
    id: 'fastCover.StepMedicalExpenses.tourGuide',
    defaultMessage: 'Tour Guide',
  },

  notReported: {
    id: 'fastCover.StepMedicalExpenses.notReported',
    defaultMessage: 'Not Reported',
  },

  addItem: {
    id: 'fastCover.StepMedicalExpenses.addItem',
    defaultMessage: 'Add Expense',
  },

  itemWithIdx: {
    id: 'fastCover.StepMedicalExpenses.itemWithIdx',
    defaultMessage: 'Item(s) {idx}',
  },

  item: {
    id: 'fastCover.StepMedicalExpenses.item',
    defaultMessage: 'Item',
  },

  estimatedValue: {
    id: 'fastCover.StepMedicalExpenses.estimatedValue',
    defaultMessage: 'Estimated Value',
  },

  haveYouReceivedReimbursement: {
    id: 'fastCover.StepMedicalExpenses.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received Reimbursement?',
  },

  fromWhom: {
    id: 'fastCover.StepMedicalExpenses.fromWhom',
    defaultMessage: 'If so, from whom?',
  },

  howMuch: {
    id: 'fastCover.StepMedicalExpenses.howMuch',
    defaultMessage: 'How much?',
  },

  totalExpensesClaimed: {
    id: 'fastCover.StepMedicalExpenses.totalExpensesClaimed',
    defaultMessage: 'Total Expenses Claimed',
  },

  addPrescriptionMedicines: {
    id: 'fastCover.StepMedicalExpenses.addPrescriptionMedicines',
    defaultMessage: 'Add Prescription medicine',
  },

  prescriptionMedicinesV1: {
    id: 'fastCover.StepMedicalExpenses.prescriptionMedicinesV1',
    defaultMessage: 'Prescription medicines you have been prescribed for your injury or illness',
  },

  dosage: {
    id: 'fastCover.StepMedicalExpenses.dosage',
    defaultMessage: 'Dosage',
  },

  nameOfPrescribingDoctor: {
    id: 'fastCover.StepMedicalExpenses.nameOfPrescribingDoctor',
    defaultMessage: 'Name of Prescribing Doctor',
  },

  prescriptionMedicinesV2: {
    id: 'fastCover.StepMedicalExpenses.prescriptionMedicinesYouHave',
    defaultMessage: 'Prescription medicines, herbal medications or vitamins you took prior to your effective date that are not related to your injury/illness',
  },

  changeTo: {
    id: 'fastCover.StepMedicalExpenses.changeTo',
    defaultMessage: 'Is this a claim due to an unexpected recurrence or a pre-existing condition?',
  },

  ifYesNameOfPhysicianCurrentlyTreatingThis: {
    id: 'fastCover.StepMedicalExpenses.ifYesNameOfPhysicianCurrentlyTreatingThis',
    defaultMessage: 'If yes, name of physician currently treating this',
  },

  // ------------------------------------------------------------------------------------

  tripCancellation: {
    id: 'fastCover.StepMedicalExpenses.tripCancellation',
    defaultMessage: 'Are you claiming for Trip Cancellation?',
  },

  travelInterruption: {
    id: 'fastCover.StepMedicalExpenses.travelInterruption',
    defaultMessage: 'Are you claiming for Travel Interruption?',
  },

  travelDelay: {
    id: 'fastCover.StepMedicalExpenses.travelDelay',
    defaultMessage: 'Are you claiming for Travel Delay?',
  },

  reasonsForTripInterruption: {
    id: 'fastCover.StepMedicalExpenses.reasonsForTripInterruption',
    defaultMessage: 'Reasons for Trip Interruption',
  },

  reasons1: {
    id: 'fastCover.StepMedicalExpenses.reasons1',
    defaultMessage: 'Death of an Immediate Family Member',
  },

  reasons2: {
    id: 'fastCover.StepMedicalExpenses.reasons2',
    defaultMessage: 'You Unforeseen Sickness or Injury or, the Sickness or Injury if a Traveling Companion or Immediate Family Member',
  },

  reasons3: {
    id: 'fastCover.StepMedicalExpenses.reasons3',
    defaultMessage: 'Substantial destruction of your principal residence by fire or weather-related activity a Medically Necessary covered Emergency Medical Evacuation to return to Your Home Country',
  },

  reasons4: {
    id: 'fastCover.StepMedicalExpenses.reasons4',
    defaultMessage: 'or to the area from which You were initially evacuated for continued treatment, recuperation, and recovery',
  },

  travelSupplier: {
    id: 'fastCover.StepMedicalExpenses.travelSupplier',
    defaultMessage: 'Travel Supplier / Provider Information',
  },

  addressTravelInterruption: {
    id: 'fastCover.StepMedicalExpenses.addressTravelInterruption',
    defaultMessage: 'Address',
  },

  cityTravelInterruption: {
    id: 'fastCover.StepMedicalExpenses.cityTravelInterruption',
    defaultMessage: 'City',
  },

  stateTravelInterruption: {
    id: 'fastCover.StepMedicalExpenses.stateTravelInterruption',
    defaultMessage: 'State',
  },

  zipCodeTravelInterruption: {
    id: 'fastCover.StepMedicalExpenses.zipCodeTravelInterruption',
    defaultMessage: 'Zip code',
  },

  contactTravelInterruption: {
    id: 'fastCover.StepMedicalExpenses.contactTravelInterruption',
    defaultMessage: 'Contact',
  },

  phoneNumberTravelInterruption: {
    id: 'fastCover.StepMedicalExpenses.phoneNumberTravelInterruption',
    defaultMessage: 'Phone Number',
  },

  includedInPackage: {
    id: 'fastCover.StepMedicalExpenses.includedInPackage',
    defaultMessage: 'If not included in package, how was air travel arranged?',
  },

  addLossInformation: {
    id: 'fastCover.StepMedicalExpenses.addLossInformation',
    defaultMessage: 'Add Loss Information',
  },

  dateTripInterrupted: {
    id: 'fastCover.StepMedicalExpenses.dateTripInterrupted',
    defaultMessage: 'Date Trip was Interrupted',
  },

  lossInformationWithIdx: {
    id: 'fastCover.StepMedicalExpenses.lossInformationWithIdx',
    defaultMessage: 'Loss information {idx}',
  },

  reasonForInterruption: {
    id: 'fastCover.StepMedicalExpenses.reasonForInterruption',
    defaultMessage: 'Reason for interruption',
  },

  nameOfPersonHavingSickness: {
    id: 'fastCover.StepMedicalExpenses.nameOfPersonHavingSickness',
    defaultMessage: 'Name of person having sickness of injury',
  },

  dateOfBirth: {
    id: 'fastCover.StepMedicalExpenses.dateOfBirth',
    defaultMessage: 'His/Her date of birth',
  },

  relationshipToClaimant: {
    id: 'fastCover.StepMedicalExpenses.relationshipToClaimant',
    defaultMessage: 'His/Her relationship to claimant',
  },

  dateSicknessOrInjuryBegan: {
    id: 'fastCover.StepMedicalExpenses.dateSicknessOrInjuryBegan',
    defaultMessage: 'Date Sickness Or Injury began',
  },

  dateEnded: {
    id: 'fastCover.StepMedicalExpenses.dateEnded',
    defaultMessage: 'Date ended',
  },

  natureOfSicknessOrInjury: {
    id: 'fastCover.StepMedicalExpenses.natureOfSicknessOrInjury',
    defaultMessage: 'Nature of Sickness or Injury (If Injury, describe accident, including date and place):',
  },

  periodOfHospitalization: {
    id: 'fastCover.StepMedicalExpenses.periodOfHospitalization',
    defaultMessage: 'Period of hospitalization (If applicable)',
  },

  companyNameLoss: {
    id: 'fastCover.StepMedicalExpenses.companyNameLoss',
    defaultMessage: 'Company name (airline/hotel/cruse/travel agent/ect.)',
  },

  amountPaidLoss: {
    id: 'fastCover.StepMedicalExpenses.amountPaidLoss',
    defaultMessage: 'Amount Paid (total for all insureds)',
  },

  amountOfLoss: {
    id: 'fastCover.StepMedicalExpenses.amountOfLoss',
    defaultMessage: 'Amount of Loss (non-refundable amount)',
  },

  howMuchReceivedReimbursement: {
    id: 'fastCover.StepMedicalExpenses.howMuchReceivedReimbursement',
    defaultMessage: 'How much?',
  },

  reasonsForDelay: {
    id: 'fastCover.StepMedicalExpenses.reasonsForDelay',
    defaultMessage: 'Reasons for Delay',
  },

  reasons1ForTravelDelay: {
    id: 'fastCover.StepMedicalExpenses.reasons1ForTravelDelay',
    defaultMessage: 'Delay of a Common Carrier (including Inclement Weather)',
  },

  reasons2ForTravelDelay: {
    id: 'fastCover.StepMedicalExpenses.reasons2ForTravelDelay',
    defaultMessage: 'Delay by a traffic Accident en router to a departure, in which You or Your Traveling Companion is not directly involved',
  },

  reasons3ForTravelDelay: {
    id: 'fastCover.StepMedicalExpenses.reasons3ForTravelDelay',
    defaultMessage: 'Delay due to lost or stolen passport, travel documents or money, Quarantine, hijacking, unannounced Strike, Natural Disaster, civil commotion, or riot',
  },

  reasons4ForTravelDelay: {
    id: 'fastCover.StepMedicalExpenses.reasons4ForTravelDelay',
    defaultMessage: 'A closed roadway causing cessation of travel to the destination of the Trip (substantiated by the department of transportation, state police, etc.)',
  },

  dateOfInitialPaymentDeposit: {
    id: 'fastCover.StepMedicalExpenses.dateOfInitialPaymentDeposit',
    defaultMessage: 'Date of initial payment deposit',
  },

  dateYouWereDueToDepart: {
    id: 'fastCover.StepMedicalExpenses.dateYouWereDueToDepart',
    defaultMessage: 'Date you were due to depart',
  },

  timeYouWereDueToDepart: {
    id: 'fastCover.StepMedicalExpenses.timeYouWereDueToDepart',
    defaultMessage: 'Time you were due to depart',
  },

  dateTripWasDelayed: {
    id: 'fastCover.StepMedicalExpenses.dateTripWasDelayed',
    defaultMessage: 'Date trip was delayed with Travel Supplier',
  },

  dateDelayEnded: {
    id: 'fastCover.StepMedicalExpenses.dateDelayEnded',
    defaultMessage: 'Date delay ended',
  },

  dateYouActuallyDeparted: {
    id: 'fastCover.StepMedicalExpenses.dateYouActuallyDeparted',
    defaultMessage: 'Date you actually departed',
  },

  timeYouActuallyDeparted: {
    id: 'fastCover.StepMedicalExpenses.timeYouActuallyDeparted',
    defaultMessage: 'Time you actually departed',
  },

  delayInformation: {
    id: 'fastCover.StepMedicalExpenses.delayInformation',
    defaultMessage: 'Delay Information',
  },

  addDelayInformation: {
    id: 'fastCover.StepMedicalExpenses.addDelayInformation',
    defaultMessage: 'Add Delay Information',
  },

  delayInformationWithIdx: {
    id: 'fastCover.StepMedicalExpenses.delayInformationWithIdx',
    defaultMessage: 'Delay information {idx}',
  },

  //-----------------------------------------------------------------------------------------

  howItHappened: {
    id: 'fastCover.StepMedicalExpenses.howItHappened',
    defaultMessage: '1. How it happened',
  },
  whereYouWereInRelationToTheItem: {
    id: 'fastCover.StepMedicalExpenses.whereYouWereInRelationToTheItem',
    defaultMessage:
      'Provide details of where you were in relation to the item at the time of loss, theft or damage',
  },
  anyThingAdditionalToAdd: {
    id: 'fastCover.StepMedicalExpenses.anyThingAdditionalToAdd',
    defaultMessage: 'Do you have any further details to add?',
  },
  delay: {
    id: 'fastCover.StepMedicalExpenses.delay',
    defaultMessage: 'Delay',
  },
  hotelManagement: {
    id: 'fastCover.StepMedicalExpenses.hotelManagement',
    defaultMessage: 'Hotel Management',
  },
  otherDescription: {
    id: 'fastCover.StepMedicalExpenses.otherDescription',
    defaultMessage: 'If yes, please describe',
  },
  descriptionOfItems: {
    id: 'fastCover.StepMedicalExpenses.descriptionOfItems',
    defaultMessage: 'Description of items',
  },
  datePurchased: {
    id: 'fastCover.StepMedicalExpenses.datePurchased',
    defaultMessage: 'Date purchased',
  },
  storeWhereItemWasPurchased: {
    id: 'fastCover.StepMedicalExpenses.storeWhereItemWasPurchased',
    defaultMessage: 'Store where item was purchased',
  },
  purchasePrice: {
    id: 'fastCover.StepMedicalExpenses.purchasePrice',
    defaultMessage: 'Purchase price',
  },
  amountClaimed: {
    id: 'fastCover.StepMedicalExpenses.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  proofOfPurchaseAttached: {
    id: 'fastCover.StepMedicalExpenses.proofOfPurchaseAttached',
    defaultMessage: 'Proof of purchase attached',
  },
  addAdditionalItem: {
    id: 'fastCover.StepMedicalExpenses.addAdditionalItem',
    defaultMessage: 'Add Additional Item',
  },
  additionalItem: {
    id: 'fastCover.StepMedicalExpenses.additionalItem',
    defaultMessage: 'Luggage and Personal Items',
  },
  claimed: {
    id: 'fastCover.StepMedicalExpenses.claimed',
    defaultMessage: 'Claimed',
  },
  nameOfTransportProvider: {
    id: 'fastCover.StepMedicalExpenses.nameOfTransportProvider',
    defaultMessage:
      'Name of Transport Provider (airline, cruise liner, bus etc.)',
  },
  dateWhenYourLuggageWasDelayed: {
    id: 'fastCover.StepMedicalExpenses.dateWhenYourLuggageWasDelayed',
    defaultMessage: 'Date when your luggage was delayed',
  },
  timeWhenYourLuggageWasDelayed: {
    id: 'fastCover.StepMedicalExpenses.timeWhenYourLuggageWasDelayed',
    defaultMessage: 'Time when your luggage was delayed',
  },
  dateWhenYourLuggageWasReturned: {
    id: 'fastCover.StepMedicalExpenses.dateWhenYourLuggageWasReturned',
    defaultMessage: 'Date when your luggage was returned',
  },
  timeWhenYourLuggageWasReturned: {
    id: 'fastCover.StepMedicalExpenses.timeWhenYourLuggageWasReturned',
    defaultMessage: 'Time when your luggage was returned',
  },
  paidForDelay: {
    id: 'fastCover.StepMedicalExpenses.paidForDelay',
    defaultMessage: 'Were you paid any compensation for this delay?',
  },
  madeClaimWithTravelProviderOrOther: {
    id: 'fastCover.StepMedicalExpenses.madeClaimWithTravelProviderOrOther',
    defaultMessage:
      'Have you made a claim with your Travel Provider (Airline, hotel, cruise liner, tour company etc.) or any other company responsible for the loss, theft, damage or delay of your luggage?',
  },
  listedOnThePolicy: {
    id: 'fastCover.StepMedicalExpenses.listedOnThePolicy',
    defaultMessage:
      'Are the luggage or personal item(s) lost, stolen, damaged or delayed owned by you or someone else listed on the policy?',
  },
  damagedLostOrStolenLuggageItems: {
    id: 'fastCover.StepMedicalExpenses.damagedLostOrStolenLuggageItems',
    defaultMessage: 'Damaged, Lost or Stolen Luggage Items',
  },
  delayedLuggageExpenses: {
    id: 'fastCover.StepMedicalExpenses.delayedLuggageExpenses',
    defaultMessage: 'Delayed Luggage Expenses',
  },
  delayedLuggageExpense: {
    id: 'fastCover.StepMedicalExpenses.delayedLuggageExpense',
    defaultMessage: 'Delayed Luggage Expense',
  },
  isRequired: {
    id: 'fastCover.StepMedicalExpenses.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  expenseTableRequired: {
    id: 'fastCover.StepMedicalExpenses.expenseTableRequired',
    defaultMessage: 'Expense table fields are mandatory fields.',
  },
  addDelayedLuggageExpense: {
    id: 'fastCover.StepMedicalExpenses.addDelayedLuggageExpense',
    defaultMessage: 'Add Delayed Luggage Expense',
  },
  dateCompensationWasReceived: {
    id: 'fastCover.StepMedicalExpenses.dateCompensationWasReceived',
    defaultMessage: 'Date compensation was received',
  },
  compensationDescription: {
    id: 'fastCover.StepMedicalExpenses.compensationDescription',
    defaultMessage: 'Compensation description',
  },
  amountOfCompensation: {
    id: 'fastCover.StepMedicalExpenses.delayedTravel.amountOfCompensation',
    defaultMessage: 'Compensation received',
  },
  amountOfCompensationCurrency: {
    id: 'fastCover.StepMedicalExpenses.delayedTravel.amountOfCompensationCurrency',
    defaultMessage: 'Currency',
  },
  currencyEg: {
    id: 'fastCover.StepMedicalExpenses.currencyEg',
    defaultMessage: 'E.g.Euro',
  },
  delayedLuggageExpenseWithIdx: {
    id: 'fastCover.StepMedicalExpenses.delayedLuggageExpenseWithIdx',
    defaultMessage: 'Delayed Luggage Expense {idx}',
  },
  checkEventDate: {
    id: 'fastCover.stepMedicalExpenses.checkEventDate',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },
  expenseFor: {
    id: 'fastCover.stepMedicalExpenses.expenseFor',
    defaultMessage: 'Expense For',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepMedicalExpenses/messages.js